import { ReactNode } from 'react';

export const NodeOl = (children: ReactNode) => <ol className="pl-5">{children}</ol>;
